export default __webpack_public_path__ + "static/media/bg.2105e0ea.jpg";